import { createFileRoute, useRouter } from '@tanstack/react-router'
import { toast } from 'sonner'
import ModalPopup from '@/components/ui/ModalPopup'
import useBookingMutation from '@/hooks/useBookingMutation'
import { isHttpError } from '@/utils/http'

export const Route = createFileRoute('/my-booking/$id/view/cancel')({
  component: RouteComponent,
})

function RouteComponent() {
  const bookingId = Route.useParams({
    select: (s) => s.id,
  })
  const router = useRouter()
  const { cancelUnpaid } = useBookingMutation()
  const onConfirmCancel = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault()
    return cancelUnpaid.mutate(
      {
        id: bookingId,
      },
      {
        onSuccess: () => {
          toast.success('Your unpaid booking has been cancelled successfully.')
          return router.history.back()
        },
        onError: async (err) => {
          if (isHttpError(err)) {
            const res = await err.response.json()
            return toast.error('message' in res ? res.message : res.error)
          }
          return toast.error('Something went wrong')
        },
      },
    )
  }
  return (
    <ModalPopup
      opened
      onClose={() => router.history.back()}
      onConfirm={onConfirmCancel}
      isPending={cancelUnpaid.isPending}
      title="Cancel Booking?"
      description="This booking hasn’t been paid yet. Canceling will remove it from your bookings permanently."
      bgColor="#D21C1C"
      confirmLabel="Cancel Booking"
      closeLabel="Keep Booking"
    />
  )
}
